import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from 'services/api/api';
import { mapErrorToToastProps } from 'utils/forms/mapErrorToToastProps';

import { familyMessages } from '../variables/familyMessages';

export const updateProductModel = async (reqBody, id) => {
	const response = await api.patch(`/model-product?id=${id}`, {
		...reqBody,
	});
	return response.data;
};
export const useUpdateProductModel = (body, id) => {
	const queryClient = useQueryClient();
	const toast = useToast();

	return useMutation(() => updateProductModel(body, id), {
		onSuccess: sucess => {
			queryClient.invalidateQueries(['model-product']);
			queryClient.invalidateQueries(['model-product-list']);

			queryClient.refetchQueries(['model-product']);
			queryClient.refetchQueries(['model-product-list']);

			toast({
				title: familyMessages.MSG_MODEL_UPDATED_SUCCESS,
				description: familyMessages.MSG_MODEL_UPDATED_SUCCESS,
				position: 'bottom-left',
				status: 'success',
				duration: 8000,
				isClosable: true,
			});
		},
		onError: (error: any, variables, context) => {
			const toastErrors: Array<any> = mapErrorToToastProps(
				error,
				familyMessages.MSG_MODEL_UPDATE_ERROR
			);
			toastErrors?.forEach(element => toast(element));
		},
	});
};
